import BookUniverse from "../components/BookUniverse";
import "../components/BookUniverse.css";
import "./TrailScreen.css";

/**
 * 우주 궤적.
 *
 * 예전에는 사람을 세로로 한 줄에 세우고 겹치는 책으로 이어 붙였다.
 * 사슬 모양이라 누가 누구와 이어졌는지는 보였지만, 어느 책이 몇 명을
 * 잇고 있는지는 보이지 않았고 한 줄에 담을 수 있는 사람 수도 제한됐다.
 *
 * 이웃 화면의 '겹치는 책' 과 같은 그림으로 바꾼다. 겹치는 책을 가운데
 * 노드로 두면 책마다 몇 명이 모였는지가 크기로 드러난다.
 */
const TrailScreen = ({ allBooks, users, currentUser, onBack, onBookClick, onUserClick }) => (
  <div className="bp-layer trail-screen">
    <div className="trail-header">
      <button className="trail-back" onClick={onBack}>← 돌아가기</button>
      <div className="trail-title">우주 궤적</div>
    </div>

    <div className="trail-container">
      {/* 안내는 화면마다 다시 쓰지 않고 여기서만 한 줄 둔다 */}
      <div className="trail-info">같은 책을 담았으면 한 권만 겹쳐도 이어집니다</div>
      <BookUniverse
        users={users}
        allBooks={allBooks}
        myId={currentUser?.uid}
        onUserClick={onUserClick}
        onBookClick={onBookClick}
      />
    </div>
  </div>
);

export default TrailScreen;
